import { ArrowBack as BackIcon, NewReleases as NewReleasesIcon } from '@mui/icons-material'
import { Box, Button, Card, CardContent, CircularProgress, Typography } from '@mui/material'
import * as React from 'react'
import { Title, useTranslate } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import EmptyState from '../components/EmptyState'
import PageHeader from '../components/PageHeader'
import ReleaseNoteBody from './ReleaseNoteBody'
import { writeLastSeen } from './releaseNotes'
import { useReleaseNotes } from './useReleaseNotes'

/** Help → What's new: every shipped note, newest first. */
export const WhatsNewPage: React.FC = () => {
  const translate = useTranslate()
  const navigate = useNavigate()
  const { entries, loading } = useReleaseNotes()

  // Reading the full list is the strongest possible acknowledgement of the
  // latest note — do not show the notice afterwards.
  React.useEffect(() => {
    if (entries[0]) writeLastSeen(entries[0].id)
  }, [entries])

  return (
    <Box sx={{ maxWidth: 900 }}>
      <Title title={translate('pos.whats_new.page_title')} />
      <PageHeader
        eyebrow={
          <Button
            size="small"
            startIcon={<BackIcon />}
            onClick={() => navigate('/help')}
            sx={{ ml: -1, color: 'text.secondary' }}
          >
            {translate('pos.whats_new.back_to_help')}
          </Button>
        }
        title={translate('pos.whats_new.title')}
      />

      {loading && <CircularProgress size={24} sx={{ my: 2 }} />}
      {/* Nothing published is a neutral state, not an info-blue notice. */}
      {!loading && entries.length === 0 && (
        <Card>
          <EmptyState icon={<NewReleasesIcon />} title={translate('pos.whats_new.empty')} />
        </Card>
      )}

      {entries.map((entry) => (
        <Card key={entry.id} sx={{ mb: 2 }} data-release-note-id={entry.id}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1, flexWrap: 'wrap' }}>
              <Typography variant="h6" component="h2">
                {entry.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {entry.date}
              </Typography>
            </Box>
            <ReleaseNoteBody body={entry.body} />
          </CardContent>
        </Card>
      ))}
    </Box>
  )
}

export default WhatsNewPage
